export const WorkoutList = {
  bindings: {
    exercises: '<',
    member: '<',
    params: '<',
    workout: '<',
    onStart: '&',
  },

  template: `
    <div class="workout-list">
      <workout-meta
        workout="$ctrl.workout"
        member="$ctrl.member">
      </workout-meta>
      <workout-section
        ng-repeat="item in $ctrl.workout.items track by $index"
        section="item"
        workout="$ctrl.workout"
        exercises="$ctrl.exercises"
        gender="$ctrl.member.profile.gender"
        params="$ctrl.params"
        on-show-modal="$ctrl.onShowModal(item)">
      </workout-section>
      <modal
        size="md"
        target="modalVideoExercise"
        on-hidden="$ctrl.onHidden()">
        <modal-title>
          <span class="text-center">{{ $ctrl.modalTitle }}</span>
        </modal-title>
        <modal-body>
          <video-player
            video-id="$ctrl.modalVideoId"
            autoplay="'true'">
          </video-player>
        </modal-body>
      </modal>
    </div>`,

  controller() {
    'ngInject';

    return {
      onShowModal(item) {
        this.modalTitle = item.title;
        this.modalVideoId = item.brightcoveId;
      },

      onHidden() {
        this.modalTitle = undefined;
        this.modalVideoId = undefined;
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Workout/WorkoutList.js